'use strict';

require('./input-payment.scss');

$$('.ll-input-payment').each(function () {
    var $payment = $$(this),
        $buttons = $payment.find('.ll-input-payment__button');

    $buttons.each(function () {
        var _this = this;

        var $button = $$(this);

        $button.on('click', function (event) {

            $$('input[name="payment_gateway"]').val($$(_this).val());

            $buttons.removeClass('is-active');
            $button.addClass('is-active');

            event.preventDefault();
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./src/components/input/input-payment.js
// module id = 92
// module chunks = 0